import BreakingNews from "../../components/BreakingNews";
import SmallNewsCard from "../../components/SmallNewsCard";
import HorizontalNewsCard from "../../components/HorizontalNewsCard";
import LeftSidebar from "../../components/LeftSidebar";
import ComplexEntertainmentSection from "../../components/ComplexEntertainmentSection";
import VideoHub from "../../components/VideoHub";
import WeatherWidget from "../../components/WeatherWidget";
import RightSidebar from "../../components/RightSidebar";
import topAdBanner from "../../Assets/images/top_ad_banner_bright.jpg";
import topAdBanner2 from "../../Assets/images/top_ad_banner.jpg";
import { useEffect, useState } from "react";
import axios from "axios";
import { getNewsByFilter, getAllGallery, getStories } from "../../api/apiHandler";
import { getMediaBaseUrl } from "../../utils/backendUrl";


import ViewAllHeader from "../../common/ViewAllHeader";
import WebStoriesPage from "../../components/WebStories";
import { Link } from "react-router-dom";


import TopAdBanner from "../../components/TopAdBanner";
import LeftAdBanner from "../../components/LeftAdBanner";

// Each entry maps a Home section to its backend category/subcategory aliases.
const CATEGORY_SECTIONS = [
  {
    key: "tech",
    title: "टेक/विज्ञान",
    to: "/category/technology",
    variant: "small",
    filters: [{ category: "टेक/विज्ञान" }, { category: "technology" }, { category: "विज्ञान" }],
  },
  {
    key: "religion",
    title: "धर्म/ज्योतिष",
    to: "/category/religion",
    variant: "small",
    filters: [{ category: "धर्म/ज्योतिष" }, { category: "धर्म" }, { category: "religion" }],
  },
  {
    key: "national",
    title: "राष्ट्रीय",
    to: "/category/national",
    variant: "horizontal",
    filters: [{ category: "राष्ट्रीय" }, { category: "देश" }, { category: "national" }],
  },
  {
    key: "videsh",
    title: "विदेश",
    to: "/category/international",
    variant: "horizontal",
    filters: [{ category: "विदेश" }, { category: "international" }, { category: "world" }],
  },
  {
    key: "crime",
    title: "सिटी क्राइम",
    to: "/category/crime",
    variant: "small",
    filters: [
      { category: "अन्य", subcategory: "अपराध" },
      { subcategory: "अपराध" },
      { category: "अन्य" },
    ],
  },
  {
    key: "health",
    title: "हेल्थ+",
    to: "/category/health",
    variant: "small",
    filters: [
      { category: "स्वास्थ्य/लाइफस्टाइल" },
      { category: "स्वास्थ्य" },
      { category: "health" },
    ],
  },
  {
    key: "politics",
    title: "राजनीति",
    to: "/category/politics",
    variant: "small",
    filters: [{ category: "राजनीति" }, { category: "politics" }],
  },
  {
    key: "sports",
    title: "खेल",
    to: "/category/sports",
    variant: "small",
    filters: [{ category: "खेल" }, { category: "sports" }, { category: "sport" }],
  },
  {
    key: "business",
    title: "व्यापार",
    to: "/category/business",
    variant: "small",
    filters: [{ category: "व्यापार" }, { category: "business" }, { category: "economy" }],
  },
  {
    key: "entertainment",
    title: "मनोरंजन",
    to: "/category/entertainment",
    variant: "complex",
    fetchLimit: 13,
    filters: [{ category: "मनोरंजन" }, { category: "सिनेमा" }, { category: "entertainment" }],
  },
];

const getSection = (key) => CATEGORY_SECTIONS.find((s) => s.key === key);

const Home = () => {
  const [selectedCity, setSelectedCity] = useState("bhopal");
  const [isAdOpen, setIsAdOpen] = useState(true);
  const [sectionsData, setSectionsData] = useState({});
  const [topNewsData, setTopNewsData] = useState([]);
  const [galleryItems, setGalleryItems] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [bollywoodVideos, setBollywoodVideos] = useState([]);
  const [webStoriesMarquee, setWebStoriesMarquee] = useState([]);

  useEffect(() => {
    console.log("window.scrollY =", window.scrollY);
    const left = document.querySelector(".left");
    console.log("left.scrollTop =", left?.scrollTop);
  }, []);

  const BASE_URL = getMediaBaseUrl();

  const mapProductToCard = (item) => {
    let imageUrl = "";
    if (item.thumbnail) {
      if (item.thumbnail.startsWith("http")) {
        imageUrl = item.thumbnail;
      } else if (item.thumbnail.startsWith("/images/")) {
        imageUrl = item.thumbnail;
      } else {
        imageUrl = `${BASE_URL}/uploads/news/${encodeURIComponent(item.thumbnail)}`;
      }
    }

    return {
      id: item.id,
      image: imageUrl,
      category: item.category || "",
      title: item.news_title || item.title || "",
      author: item.reporter_name || "न्यूज़ डेस्क",
      date: item.createdAt ? new Date(item.createdAt).toLocaleDateString("hi-IN") : "",
      readTime: "2 मिनट पढ़ें",
      fullNews: item.description || item.fullNews || "",
      videoUrl: item.youtube_url || "",
      link: item.id ? `/news/${item.id}` : item.link,
    };
  };

  const fetchSectionNews = async (filters, limit = 6) => {
    const seen = new Set();
    const results = [];
    for (const filter of filters) {
      try {
        const res = await getNewsByFilter({ ...filter, limit });
        const items = Array.isArray(res?.data) ? res.data : [];
        for (const item of items) {
          if (!item.id || seen.has(item.id)) continue;
          seen.add(item.id);
          results.push(mapProductToCard(item));
          if (results.length >= limit) return results;
        }
      } catch (err) {
        console.error("Error fetching section news:", err);
      }
    }
    return results;
  };

  useEffect(() => {
    let isMounted = true;

    const loadTopNews = async () => {
      try {
        const res = await getNewsByFilter({ limit: 20 });
        const items = Array.isArray(res?.data) ? res.data : [];
        if (isMounted) {
          const mapped = items.map(mapProductToCard);
          const shuffled = [...mapped].sort(() => Math.random() - 0.5);
          setTopNewsData(shuffled.slice(0, 6));
        }
      } catch (err) {
        console.error("Error fetching top news:", err);
      }
    };

    const loadGallery = async () => {
      try {
        const res = await getAllGallery();
        const items = Array.isArray(res?.data) ? res.data : [];
        if (isMounted) {
          const mapped = items.map((item) => ({
            id: item.id,
            name: item.name || "",
            image: item.image
              ? `${BASE_URL}/uploads/gallery/${encodeURIComponent(item.image)}`
              : "",
          }));
          setGalleryItems(mapped.slice(0, 8));
        }
      } catch (err) {
        console.error("Error fetching gallery:", err);
      }
    };

    const loadCategorySections = async () => {
      const entries = await Promise.all(
        CATEGORY_SECTIONS.map(async (sec) => [sec.key, await fetchSectionNews(sec.filters, sec.fetchLimit || 6)])
      );

      if (isMounted) {
        setSectionsData(Object.fromEntries(entries));
      }
    };

    const loadBollywoodVideos = async () => {
      try {
        const res = await getNewsByFilter({ category: "video news", limit: 15 });
        const items = Array.isArray(res?.data) ? res.data : [];
        if (isMounted) {
          const mapped = items.map((item) => ({
            id: item.id,
            title: item.news_title || item.title || "",
            image: item.thumbnail
              ? item.thumbnail.startsWith("http")
                ? item.thumbnail
                : item.thumbnail.startsWith("/images/")
                  ? item.thumbnail
                  : `${BASE_URL}/uploads/news/${encodeURIComponent(item.thumbnail)}`
              : "",
            readTime: "04:30",
          }));
          setBollywoodVideos(mapped.slice(0, 6));
        }
      } catch (err) {
        console.error("Error fetching bollywood videos:", err);
      }
    };

    const loadWebStories = async () => {
      try {
        const res = await getStories();
        const items = Array.isArray(res?.data) ? res.data : [];
        if (isMounted) {
          const stories = items.map(item => ({
            id: item.id,
            heading: item.heading || (Array.isArray(item.image_headings) ? item.image_headings[0] : "") || "वेब स्टोरी"
          }));
          setWebStoriesMarquee(stories);
        }
      } catch (err) {
        console.error("Error fetching web stories for marquee:", err);
      }
    };

    loadTopNews();
    loadCategorySections();
    loadGallery();
    loadBollywoodVideos();
    loadWebStories();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sectionItems = (sec, limit = 6) => {
    return (sectionsData[sec.key] || []).slice(0, limit);
  };

  const CategorySection = ({ sec }) => {
    const items = sectionItems(sec);

    if (sec.variant === "horizontal") {
      return (
        <section>
          <ViewAllHeader title={sec.title} to={sec.to} />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-4 md:gap-y-5">
            {items.map((item, i) => (
              <HorizontalNewsCard key={item.id || `${sec.key}-${i}`} {...item} />
            ))}
          </div>
        </section>
      );
    }

    return (
      <section className="my-8 pt-6 border-t border-gray-200">
        <ViewAllHeader title={sec.title} to={sec.to} />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-1.5 md:gap-x-2 gap-y-4 md:gap-y-5">
          {items.map((item, i) => (
            <SmallNewsCard key={item.id || `${sec.key}-${i}`} {...item} />
          ))}
        </div>
      </section>
    );
  };

  // Static JSON usage
  const getEmbedUrl = (url) => {
    if (!url) return "";

    const match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    if (match) return `https://www.youtube.com/embed/${match[1]}`;

    return url.includes("youtube.com/") || url.includes("youtu.be") ? "" : url;
  };


  return (
    <>
      {/* TOP AD BANNER (Auto Scrollable Slider) */}
      <TopAdBanner />

      {/* WRAPPER FOR SIDE ADS & CONTENT */}
      <div className="relative w-full max-w-[1600px] mx-auto flex justify-center items-start gap-4">
        
        {/* MAIN CONTENT AREA */}
        <div className="w-full max-w-[1400px] px-4 sm:px-5 md:px-6 lg:px-8 py-3 md:py-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-8">
          
          {/* ================= LEFT AD SIDEBAR (With Weather) ================= */}
          <div className="hidden lg:block lg:col-span-2">
            <div className="space-y-3 sticky top-[70px]">
              {/* ADVERTISEMENT 1 (Auto-rotating Image Ads) */}
              <LeftAdBanner />

              {/* WEATHER WIDGET */}
              <div>
                <WeatherWidget defaultCity="खजुराहो" />
              </div>


            </div>
          </div>

          {/* ================= MAIN CONTENT AREA ================= */}
          <div className="lg:col-span-10 flex flex-col">
            
            {/* ================= HERO SECTION ================= */}
            <div className="lg:col-span-10 space-y-6">
          
              {/* 🔴 BREAKING NEWS TICKER (ACTING AS HERO HEADER) */}
              <div className="w-full bg-brand-purple text-white flex items-center px-4 py-2.5 rounded-lg shadow-md overflow-hidden">
                <div className="font-black shrink-0 pr-4 border-r border-purple-400 uppercase tracking-wide flex items-center gap-2 text-lg">
                  <i className="fa-solid fa-bolt animate-pulse text-brand-red"></i>
                  ब्रेकिंग न्यूज़
                </div>
                {webStoriesMarquee.length > 0 ? (
                  <marquee className="ml-4 font-medium text-[16px]" scrollamount="6">
                    {webStoriesMarquee.map((story, i) => (
                      <span key={story.id || i} className="mx-6 hover:underline">
                        <Link to={`/web-stories/${story.id}`}>• {story.heading}</Link>
                      </span>
                    ))}
                  </marquee>
                ) : (
                  <marquee className="ml-4 font-medium text-[16px]" scrollamount="6">
                    <span className="mx-6">• मध्य प्रदेश: मोहन कैबिनेट के अहम फैसले, कई योजनाओं को मिली मंजूरी</span>
                    <span className="mx-6">• शेयर बाजार में भारी उछाल, सेंसेक्स ने छुआ रिकॉर्ड स्तर</span>
                    <span className="mx-6">• मौसम अलर्ट: प्रदेश के कई जिलों में भारी बारिश की चेतावनी जारी</span>
                    <span className="mx-6">• खेल जगत: भारतीय टीम ने निर्णायक मुकाबले में दर्ज की शानदार जीत</span>
                  </marquee>
                )}
              </div>

              {/* 🔹 HERO SECTION (TOP NEWS + RIGHT SIDEBAR) */}
              <div className="flex flex-col lg:grid lg:grid-cols-10 gap-6">
                
                {/* TOP NEWS (SPAN 8) */}
                <div className="order-2 lg:order-1 lg:col-span-8">
                  <section>
                    {/* Compact Vertical List of 6 Cards */}
                    <div className="flex flex-col gap-3">
                      {(topNewsData.length > 0 ? topNewsData : []).map((item, i) => (
                        <HorizontalNewsCard key={item.id || i} {...item} compact={true} />
                      ))}
                    </div>
                  </section>
                </div>

                {/* RIGHT SIDEBAR (SPAN 2) */}
                <aside className="order-1 lg:order-2 lg:col-span-2">
                  <RightSidebar />
                </aside>
              </div>

              {/* MOBILE AD SECTION (Visible only on mobile) */}
              <div className="block lg:hidden space-y-4 my-4">
                <LeftAdBanner />
                <WeatherWidget defaultCity="खजुराहो" />
              </div>
            </div>

            {/* 🟢 NEW SECTION: Technology */}
            <CategorySection sec={getSection("tech")} />

            {/* 🟢 NEW SECTION: Dharma Jyotish */}
            <CategorySection sec={getSection("religion")} />

            {/* 🟡 WEB STORIES SECTION */}
            <section className="mb-6 md:mb-12 mt-6 md:mt-10">
              <ViewAllHeader title="वेब स्टोरीज"  />
              <WebStoriesPage />
            </section>

            {/* ================= CATEGORIES ALONGSIDE LEFT SIDEBAR ================= */}
            <div className="space-y-6 md:space-y-12 pt-4 md:pt-6 border-t border-gray-200">
            
            {/* 1. NATIONAL (Using Horizontal List Format) */}
            <CategorySection sec={getSection("national")} />

            {/* 2. INTERNATIONAL */}
            <CategorySection sec={getSection("videsh")} />

            {/* 🔹 TOI-STYLE VIDEO HUB */}
            <VideoHub />

            {/* 🟢 NEW 6-COLUMN SECTION: CITY CRIME */}
            <CategorySection sec={getSection("crime")} />

            {/* 🟢 NEW 6-COLUMN SECTION: HEALTH+ */}
            <CategorySection sec={getSection("health")} />

            {/* 3. POLITICS */}
            <CategorySection sec={getSection("politics")} />

            {/* 4. BUSINESS (from backend) */}
            <CategorySection sec={getSection("business")} />



            {/* 📸 TOI-STYLE PHOTO GALLERY (IN PICS) - PREMIUM VERTICAL FORMAT */}
            {galleryItems.length > 0 && (
              <section className="my-8 md:my-12 py-8 md:py-12 bg-rich-black -mx-4 px-4 lg:-mx-8 lg:px-8 rounded-none">
                <div className="flex justify-between items-end mb-6">
                  <h2 className="text-2xl md:text-3xl font-black text-white uppercase tracking-wide flex items-center gap-3">
                    <i className="fa-solid fa-camera text-brand-red"></i> तस्वीरें (In Pics)
                  </h2>
                  <Link to="/gallery/photos" className="text-gray-400 hover:text-white text-sm font-bold transition">सभी देखें &rarr;</Link>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                  {galleryItems.map((item, i) => (
                    <div key={item.id || i} onClick={() => setLightboxIndex(i)} className="relative rounded-xl overflow-hidden cursor-pointer group shadow-sm hover:shadow-xl transition-all duration-300">
                      <div className="w-full aspect-[4/5]">
                        <img src={item.image} alt={item.name || "गैलरी"} className="w-full h-full object-cover group-hover:scale-110 transition duration-700" />
                      </div>

                      {/* Black overlay on hover */}
                      <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-80 transition-opacity duration-500"></div>

                      {/* Full heading appears on hover */}
                      <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                        <h3 className="text-white text-sm md:text-base font-bold leading-snug drop-shadow-md translate-y-4 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                          {item.name}
                        </h3>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* 🔹 GALLERY LIGHTBOX (FULLSCREEN) */}
            {lightboxIndex !== null && galleryItems[lightboxIndex] && (
              <div className="fixed inset-0 z-[9999] bg-black/95 flex items-center justify-center p-4" onClick={() => setLightboxIndex(null)}>
                {/* Close Button */}
                <button
                  className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-brand-red text-white text-xl transition"
                  onClick={() => setLightboxIndex(null)}
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>

                {/* Prev Button */}
                <button
                  className="absolute left-4 md:left-8 z-10 w-11 h-11 flex items-center justify-center rounded-full bg-white/10 hover:bg-brand-red text-white text-xl transition"
                  onClick={(e) => {
                    e.stopPropagation();
                    setLightboxIndex((prev) => (prev - 1 + galleryItems.length) % galleryItems.length);
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>

                {/* Next Button */}
                <button
                  className="absolute right-4 md:right-8 z-10 w-11 h-11 flex items-center justify-center rounded-full bg-white/10 hover:bg-brand-red text-white text-xl transition"
                  onClick={(e) => {
                    e.stopPropagation();
                    setLightboxIndex((prev) => (prev + 1) % galleryItems.length);
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>

                <div className="max-w-5xl w-full">
                  <img
                    src={galleryItems[lightboxIndex].image}
                    alt={galleryItems[lightboxIndex].name || "गैलरी"}
                    className="w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
                  />
                  <h3 className="text-white text-center text-base md:text-lg font-bold mt-4 px-2">
                    {galleryItems[lightboxIndex].name}
                  </h3>
                </div>
              </div>
            )}

            {/* 5. SPORTS */}
            <CategorySection sec={getSection("sports")} />
            
            {/* 6. COMPLEX ENTERTAINMENT / BOLLYWOOD (Added at bottom as requested) */}
            <ComplexEntertainmentSection
              news={sectionItems(getSection("entertainment"), 13)}
              videos={bollywoodVideos}
            />

          </div>
        </div>
        </div>
        </div>

      </div>
    </>
  );
};

export default Home;
